import { render, staticRenderFns } from "./KeywordToolbar.vue?vue&type=template&id=4c62be99&"
import script from "./KeywordToolbar.vue?vue&type=script&lang=js&"
export * from "./KeywordToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports